import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;

export const selectIsOperationInProgress = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.isOperationInProgress;
  };
  (selector as any)._fromSelector = "isOperationInProgressSelector";
  return selector;
};
